









import VueOptions from '@utils/VueOptions'
import UiListItem from './ListItem'
import axios from 'axios'

api = 'http://localhost:8080/api/v2/super/suppliers/page/{{PAGE}}?render_as_event=true&per_page=30'

settings = 
  name: 'UIList'
  components: { UiListItem }
  vue:
    props: ['slug']
    data: ->
      return
        page: 1
        list: []

    methods:
      infiniteHandler: ($state) ->
        _this = this
        prefixUrl = 'http://localhost:8080/api/v2/'
        sufixUrl = "/page/#{_this.page}?render_as_event=true&per_page=30"
        url = prefixUrl + _this.slug + sufixUrl

        axios.get(
          url,
          {
            headers: {
              X_RECESS_API_TOKEN : 'recess.api.token'
              X_AUTH_TOKEN : 'member.token.super'
            }
          }
        )
          .then((response) ->
            collection = response.data.collection

            if collection.length
              _this.page += 1
              _this.list.push(...collection)
              $state.loaded()
            else
              $state.complete()
        )
          .catch((err) -> console.err('ERR:', err))

export default VueOptions.vue settings
